import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { IconArrowLeft, IconUpload, Table } from '@ui/src';
import { useAppSelector } from '@store';
import { ongoingColumns, ongoingColumnsLabels } from './variables/ongoing';
import formatOngoingMonitroing from '../../individual/helpers/format-ongoing-monitoring';
import { OrganizationType, OngoingMonitring } from '../types';
import { OngoingMonitoringTypes } from './types';

import cn from './ongoing-monitoring.module.css';

const OngoingMonitoring = ({
  setShowOngoing,
  onRowClick,
  isLoading,
  type,
  getOngoingMonitroing,
  setExportPdfPanelVisible,
  exportAvailable,
}: OngoingMonitoringTypes) => {
  const {
    individualCustomers: {
      info: {
        aml: { ongoingMonitoring, ongoingMonitoringPagination },
      },
    },
    corporateCustomers: {
      info: {
        aml: {
          ongoingMonitoring: corporateOngoingMonitoring,
          ongoingMonitoringPagination: corporateOngoingMonitoringPagination,
        },
      },
    },
  } = useAppSelector((state) => state);

  const { customerId } = useParams();

  const dataValues =
    type === OrganizationType.INDIVIDUAL ||
    type === OrganizationType.COMPANY_OFFICIAL
      ? ongoingMonitoring
      : corporateOngoingMonitoring;
  const pagination =
    type === OrganizationType.INDIVIDUAL ||
    type === OrganizationType.COMPANY_OFFICIAL
      ? ongoingMonitoringPagination
      : corporateOngoingMonitoringPagination;

  const formattedData = useMemo(() => {
    const data = formatOngoingMonitroing(dataValues as OngoingMonitring[]);

    return data;
  }, [dataValues]);

  return (
    <div className={cn.ongoingWrapper}>
      {type !== OrganizationType.COMPANY_OFFICIAL && (
        <button
          type="button"
          className={cn.backButton}
          onClick={() => {
            setShowOngoing(false);
            getOngoingMonitroing({ id: customerId as string });
          }}
        >
          <IconArrowLeft width={13} height={11} />
          Back to AML
        </button>
      )}

      <div className={cn.ongoingTitle}>
        Ongoing monitoring
        {exportAvailable && (
          <button
            type="button"
            className={cn.ongoingExport}
            onClick={() => setExportPdfPanelVisible(true)}
          >
            <IconUpload />
            Export PDF
          </button>
        )}
      </div>
      <div className={cn.ongoingTableWrapper}>
        <Table
          columns={ongoingColumns}
          data={formattedData || []}
          sort={{}}
          onSort={() => {}}
          filters={{}}
          columnsLabels={ongoingColumnsLabels}
          tableBodyClassName={!dataValues?.length ? cn.emptyOngoing : ''}
          onFilterChange={() => {}}
          onRowClick={onRowClick}
          isLoading={isLoading}
          pagination={pagination}
          take="40"
          setPage={(data) =>
            getOngoingMonitroing({
              id: customerId as string,
              take: data.take,
              cursor: data.id,
            })
          }
        />
      </div>
    </div>
  );
};

export default OngoingMonitoring;
